module.exports = __webpack_public_path__ + "img/reward_1000.9672c564.png";